module.exports = __webpack_public_path__ + "9788f41e/img/cadBim.e369a02a.png";